import { useEffect } from 'react';
import { UnauthorizedContent } from './UnauthorizedContent';

export default function UnauthorizedPage() {
  useEffect(() => {
    document.title = 'Access Denied';
  }, []);

  return (
    <main className="min-h-screen flex items-center justify-center bg-gradient-to-b from-slate-50 to-slate-100 dark:from-slate-900 dark:to-slate-800 px-4">
      <UnauthorizedContent />
    </main>
  );
}
